import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAssignSalesReps = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0 2a6 6 0 0 1 6 6H2a6 6 0 0 1 6-6Zm8-4a1 1 0 1 0-2 0v1h-1a1 1 0 1 0 0 2h1v1a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2h-1V7Z",
		fill: "var(--main-color)"
	})
});
export { SvgAssignSalesReps as ReactComponent };
